export default __webpack_public_path__ + "images/checked_d98532.svg";